import { useTranslation } from "react-i18next";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/feature/JsonLd";
import { websiteSchema, organizationSchema } from "@/lib/schema";
import Hero from "./components/Hero";
import CategoryDropdown from "./components/CategoryDropdown";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedSection from "./components/FeaturedSection";
import ArticleSection from "./components/ArticleSection";
import CtaSection from "./components/CtaSection";

export default function Home() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Header />
      <main>
        <Hero />

        <section id="categories" className="bg-background-50">
          <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
            <div className="mx-auto max-w-2xl text-center">
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
                {t("categories.title")}
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
                {t("categories.subtitle")}
              </p>
            </div>

            <div className="mt-8 flex justify-center">
              <CategoryDropdown />
            </div>

            <div className="mt-8">
              <CategoryGrid />
            </div>
          </div>
        </section>

        <FeaturedSection />
        <ArticleSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}